const API_URL = import.meta.env.VITE_GETSIGN_API_URL;

export const createNewColumn = async ({ boardId, columnType, columnName, itemId }) => {
  const sessionToken = localStorage.getItem('sessionToken');

  const res = await fetch(
    `${API_URL}/monday/create-new-column/${boardId}/${columnType}/${columnName}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        sessionToken: sessionToken,
      },
      body: JSON.stringify({
        itemId,
      }),
    },
  );
  const response = await res.json();
  return response;
};

export const createNewEmailColumn = async ({
  boardId,
  columnType,
  columnName,
  itemId,
}) => {
  const sessionToken = localStorage.getItem('sessionToken');
  const api = `${API_URL}/board/add-column/${boardId}`;
  const res = await fetch(api, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      sessionToken: sessionToken,
    },
    body: JSON.stringify({
      title: columnName,
      description: '',
      column_type: columnType,
      itemId,
    }),
  });
  const response = await res.json();
  return response;
};

export const getEmailColumnValue = async (itemId, columns) => {
  const sessionToken = localStorage.getItem('sessionToken');
  const api = `${API_URL}/monday/get-email-column-values`;

  const res = await fetch(api, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      sessionToken: sessionToken,
    },
    body: JSON.stringify({
      itemId,
      columns,
    }),
  });

  const response = await res.json();

  return response;
};

export const updateUrlLabel = async ({ boardId, itemId, columnId, value }) => {
  const sessionToken = localStorage.getItem('sessionToken');

  const res = await fetch(
    `${API_URL}/monday/update-url-label/${boardId}/${itemId}/${columnId}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        sessionToken: sessionToken,
      },
      body: JSON.stringify({
        value,
      }),
    },
  );
  const response = await res.json();
  return response;
};
